import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  ElementRef, EventEmitter,
  Input,
  NgZone,
  OnInit, Output,
  ViewChild
} from '@angular/core';
import {PdfJsViewerComponent} from 'ng2-pdfjs-viewer';
import {FormBuilder, FormGroup} from '@angular/forms';
import {CdkDragEnd} from '@angular/cdk/drag-drop';
import {Resource} from '../../user/model/Resource';
import {LocalStorage} from '../../global/util/LocalStorage';
import {Stamprubrictemporal} from '../../user/model/Stamprubrictemporal';
import {CloneTool} from '../../global/util/CloneTool';
import {InformType} from '../../global/util/enum/InformType';
import {Dialog} from '../../global/util/Dialog';
import {
  AssignSignatureDescriptionComponent
} from '../assign-signature-description/assign-signature-description.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {TypeSignature} from '../../global/util/TypeSignature';
import {TranslateService} from '@ngx-translate/core';
import {PagestampState} from '../../global/util/PagestampState';
import {Observable, Subscription} from 'rxjs';

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.css']
})
export class PdfViewerComponent implements OnInit, AfterContentChecked {
  // Url del pdf actual
  @Input() urlStream: string;
  // Url de la imagen actual
  @Input() rubricSrc: string | ArrayBuffer;
  // Verificamos si la persona firmante es usuario con bandeja para ajustar los estilos.
  @Input() isUser: boolean;
  // persona firmante
  @Input() personId: number;
  // Parametro que define si se mostrara o no la opción de arrastre.
  @Input() showRubric: boolean;
  // Identificador del recurso actual.
  @Input() resource: Resource;
  // Identificador para saber si culmino la firma.
  @Input() signComplete: boolean;
  // identificador para saber si es el ultimo firmante.
  @Input() isLastOperator: boolean;
  // Lista de descripciones de firma digital.
  @Input() signatureDescriptions: any[] = [];
  // tipo de firma.
  @Input() typeSignature: number;
  public reloadingPdf = false;
  public pdfViewerForm: FormGroup;
  // Identificador del visor de pdf.
  @ViewChild('embeddedPdf') embeddedPdf: PdfJsViewerComponent;
  // Contenedor de la rubrica al cual se le realiza el cambio de tamaño.
  @ViewChild('resizeBox') resizeBox: ElementRef;
  // Cantidad total de paginas de un PDF.
  public pagesTotal: number;
  // Ancho del contenedor del PDF
  public pdfContainerWidth: number;
  // Alto del contenedor del PDF
  public pdfContainerHeight: number;
  // Alto del contenedor del PDF
  public pdfContainerWidth1: number;
  // titulo del modal.
  public title = 'TITLE.ADD-DIGITAL-SIGNATURE-DESCRIPTION';
  // Almacena codigo para obtener el ancho de una pagina de pdf
  public string4getWidthPdf = 'document.getElementsByTagName(\'iframe\')[0].contentDocument.activeElement.childNodes[1].childNodes[5].childNodes[13].childNodes[1].childNodes[page].clientWidth';
  // String que almacena codigo para obtener el alto de una pagina de pdf
  public string4getHeightPdf = 'document.getElementsByTagName(\'iframe\')[0].contentDocument.activeElement.childNodes[1].childNodes[5].childNodes[13].childNodes[1].childNodes[page].clientHeight';
  // String que almacena codigo para obtener el alto del contenedor de las paginas del pdf
  public string4getHeightPdfContainer = 'document.getElementsByTagName(\'iframe\')[0].contentDocument.activeElement.childNodes[1].childNodes[5].childNodes[13].childNodes[1].clientHeight';
  // String que almacena codigo para obtener el ancho del contenedor de las paginas del pdf
  public string4getWidthPdfContainer = 'document.getElementsByTagName(\'iframe\')[0].contentDocument.activeElement.childNodes[1].childNodes[5].childNodes[13].childNodes[1].clientWidth';
  public topPdfPage: number;
  // Página actual del PDF.
  public pageActual: number;
  // Estilo top para esconder la barra de tareas.
  public top4hideToolBar = -46;
  // Estilo top para esconder la barra de tareas.
  public rigth4hideToolBar = 2;
  // Limite maximo de diferencia entre hojas.
  public numberLimit = 20;
  // Porcentaje para reducir la posición al pdf real.
  public percentage4reductionPosition = 0.38;
  // Porcentaje para elevar la posicion pdf del visor.
  public percentage4reductionPosition1 = 0.62;
  // Porcentaje para aumentar la posicion pdf del visor.
  public percentage4raisePosition = 1.6;
  public rightPdfPage: number;
  // Esquinero para realizar el cambio del tamaño de la rubrica
  @ViewChild('dragHandleCorner') dragHandleCorner: ElementRef;
  // Página actual que es mostrada en el paginado
  public actualPagePaginated: number;
  // Posición "x" de la rubrica con arrastre.
  public positionDBx: number;
  // Nueva posición "x" de la rubrica al realizar arrastre.
  public newPositionX: number;
  // Nueva posición "y" de la rubrica al realizar arrastre.
  public newPositionY: number;
  // Nueva posición "Xf" de la rubrica al realizar arrastre.
  public newPositionXf: number;
  // Nueva posición "yf" de la rubrica al realizar arrastre.
  public newPositionYf: number;
  // Lista que almacena las posiciones de las rubricas de cada PDF.
  private positionRubrics: any[];
  // Ancho de rubrica original que viene desde la base de datos
  public rubricWidthDB = 240;
  // Alto de rubrica original que viene desde la base de datos
  public rubricHeightDB = 135;
  // Ultimo ancho de la rubrica de arrastre.
  public lastValueWidth: number;
  // Ultima posición "y" de la rubrica de arrastre.
  public lastValueY: number;
  // Ultimo Alto de la rubrica de arrastre.
  public lastValueHeight: number;
  // Alto de la rubrica que se mostrará para realizar el arrastre.
  public rubricHeight = 135;
  // Ancho de la rubrica que se mostrara para realizar el arrastre.
  public rubricWidth = 240;
  // Posición "y" de la rubrica con arrastre.
  public positionDBy: number;
  // PDF actual, utilizado para verificar si se necesita actualizar el visor de pdf
  public currentResourceId: number;
  public currentResourceId1: number;
  private eventsSubscription: Subscription;
  @Input() eventDragging: Observable<void>;
  @Output() rubricDragged = new EventEmitter<any>();

  constructor(private cdref: ChangeDetectorRef,
              private formBuilder: FormBuilder,
              private modalService: NgbModal,
              private ngZone: NgZone,
              private translate: TranslateService) {
    this.createForm();
  }

  ngOnInit(): void {
    this.pageActual = 1;
    this.actualPagePaginated = 1;
    this.currentResourceId = this.resource.id;
    this.currentResourceId1 = 0;
    this.eventsSubscription = this.eventDragging.subscribe(() => this.savePosition());
  }

  /**
   * Es utilizado luegod e cargar toda la pagina, para obtener las dimensiones de las paginas del PDF actual.
   */
  ngAfterContentChecked() {
    if (this.currentResourceId !== this.resource.id) {
      this.reloadPdfViewer();
      this.currentResourceId = this.resource.id;
      this.pageActual = 1;
      this.actualPagePaginated = 1;
    }
    if (this.signComplete) {
      this.reloadPdfViewer();
      this.signComplete = false;
    }
    if (this.embeddedPdf && this.embeddedPdf.PDFViewerApplication && this.showRubric) {
      this.embeddedPdf.PDFViewerApplication.secondaryToolbar.toolbar.hidden = true;
      if (this.embeddedPdf.PDFViewerApplication.pdfDocument !== null) {
        this.pagesTotal = this.embeddedPdf.PDFViewerApplication.pdfDocument._pdfInfo.numPages;
        if (this.currentResourceId1 !== this.resource.id) {
          this.setHomePage();
          this.currentResourceId1 = this.resource.id;
        }
        this.update2CurrentSize4Pdf();
        this.cdref.detectChanges();
      }
    }
    if (this.resizeBox) {
      this.setAllHandleTransform();
    }
  }

  /**
   * Establece pagina inicial,elegido desde el diseño de plantilla.
   */
  private setHomePage() {
    const positionRubric: Stamprubrictemporal = this.getPositionRubricBy(this.resource);
    this.pageActual = this.getPage(positionRubric);
    this.actualPagePaginated = this.getPage(positionRubric);
    positionRubric.page = this.pageActual;
    LocalStorage.setItem('positionRubrics', this.positionRubrics);
  }

  private getPage(positionRubric: Stamprubrictemporal): number {
    const page: number = positionRubric.page;
    switch (positionRubric.pageStamp) {
      case PagestampState.FIRST:
        return PagestampState.FIRST;
      case PagestampState.LAST:
        return this.pagesTotal;
      case PagestampState.OTHER:
        const isValidPage = this.pagesTotal >= page;
        return isValidPage ? page : PagestampState.FIRST;
    }
  }

  /**
   * Obtiene las descripcciones de la firma digital para ser mostradas en el textarea
   */
  public getDescription(): string {
    if (this.hasSignatureDescription()) {
      if (LocalStorage.getSignatureDescriptions() !== null) {
        LocalStorage.removeItem('signatureDescriptions');
      }
      let description;
      let count = 0;
      this.signatureDescriptions.forEach(value => {
        if (value.initialized) {
          if (count === 0) {
            description = value.nameView;
          } else {
            description = description + '\n' + value.nameView;
          }
          count++;
        }
      });
      return description;
    }
  }

  /**
   * Verifica si existen descripciones de firma digital.
   */
  public hasSignatureDescription(): boolean {
    return this.signatureDescriptions.length > 0;
  }

  /**
   * Verifica si tiene algun descripcción seleccionada.
   */
  public hasSignatureDescriptionActive(): boolean {
    if (TypeSignature.DIGITAL === this.typeSignature) {
      return this.signatureDescriptions.filter(value => value.initialized === true).length > 0;
    }
    return false;
  }

  /**
   * Verifica si es un firma digital
   */
  public isDigitalSignature(): boolean {
    if (this.typeSignature) {
      return TypeSignature.DIGITAL === this.typeSignature;
    }
    return false;

  }

  private reloadPdfViewer(): void {
    this.reloadingPdf = true;
    setTimeout(() => {
      this.reloadingPdf = false;
    }, 300);
  }

  public createForm() {
    this.pdfViewerForm = this.formBuilder.group(
      {
        anotherPage: [''],
        pagesTotal: [''],
      });
  }

  /**
   * Obtiene las dimensiones de la página actual del pdf.
   */
  update2CurrentSize4Pdf() {
    // tslint:disable-next-line:no-eval
    this.pdfContainerWidth = eval(this.string4getWidthPdf.replace('page', String(this.pageActual - 1)));
    this.pdfContainerWidth1 = this.pdfContainerWidth;
    // tslint:disable-next-line:no-eval
    this.pdfContainerHeight = eval(this.string4getHeightPdf.replace('page', String(this.pageActual - 1)));
    this.cdref.detectChanges();
    // tslint:disable-next-line:no-eval
    const height1 = eval(this.string4getHeightPdfContainer);
    // tslint:disable-next-line:no-eval
    const width1 = eval(this.string4getWidthPdfContainer);
    let higherHeight = 0;
    let higherWidth = 0;
    for (let index = 0; index < this.pagesTotal; index++) {
      // tslint:disable-next-line:no-eval
      const currentHeight = eval(this.string4getHeightPdf.replace('page', String(index)));
      // tslint:disable-next-line:no-eval
      const currentWidth = eval(this.string4getWidthPdf.replace('page', String(index)));
      if (currentHeight > higherHeight) {
        higherHeight = currentHeight;
      }
      if (currentWidth > higherWidth) {
        higherWidth = currentWidth;
      }
    }
    const toppdf = (height1 - this.pdfContainerHeight - 2) * -1;
    const rightpdf = (width1 - this.pdfContainerWidth - 4) * -1;
    this.topPdfPage = this.pdfContainerHeight === higherHeight ? this.top4hideToolBar : (higherHeight - this.pdfContainerHeight) > this.numberLimit ? toppdf : this.top4hideToolBar;
    this.rightPdfPage = this.pdfContainerWidth === higherWidth ? this.rigth4hideToolBar : (higherWidth - this.pdfContainerWidth) > this.numberLimit ? rightpdf : this.rigth4hideToolBar;
    this.pdfContainerWidth1 = this.pdfContainerWidth === higherWidth ? this.pdfContainerWidth1 : this.pdfContainerWidth1 + this.rightPdfPage;
  }

  /**
   * Agrega las nuevas dimensiones a la rúbrica despues de realizar el cambio de tamaño.
   */
  setAllHandleTransform() {
    const rect = this.resizeBoxElement.getBoundingClientRect();
    this.setHandleTransform(this.dragHandleCornerElement, rect, 'both');
  }

  /**
   * Obtiene los parametros del div contenedor de la rúbrica.
   */
  get resizeBoxElement(): HTMLElement {
    return this.resizeBox.nativeElement;
  }

  /**
   * Agrega las nuevas dimensiones a la rúbrica despues de realizar el cambio de tamaño.
   * @param dragHandle
   * @param targetRect
   * @param position
   */
  setHandleTransform(dragHandle: HTMLElement, targetRect: ClientRect | DOMRect, position: 'x' | 'y' | 'both') {
    const dragRect = dragHandle.getBoundingClientRect();
    const translateX = targetRect.width - dragRect.width;
    const translateY = targetRect.height - dragRect.height;

    if (position === 'x') {
      dragHandle.style.transform = `translate(${translateX}px, 0)`;
    } else if (position === 'y') {
      dragHandle.style.transform = `translate(0, ${translateY}px)`;
    } else if (position === 'both') {
      dragHandle.style.transform = `translate(${translateX}px, ${translateY}px)`;
    }
  }

  /**
   * Obtiene las dimensiones y posicion del cuadrado rojo en la esquina de rúbrica
   * que sirve para realizar el cambio de tamaño.
   */
  get dragHandleCornerElement(): HTMLElement {
    return this.dragHandleCorner.nativeElement;
  }

  /**
   * Cambia la pagina del pdf de acuerdo a la acciòn. (Subir o Bajar)
   * @param action Subir o Bajar
   */
  public changePageAfterClick(action: boolean) {
    if (action && this.pageActual > 1) {
      this.pageActual = this.pageActual - 1;
    } else if (!action && this.pageActual !== this.pagesTotal) {
      this.pageActual = this.pageActual + 1;
    }
    this.actualPagePaginated = this.pageActual;
    this.savePosition();
    this.update2CurrentSize4Pdf();
  }

  /**
   * Cambia la pagina del pdf de acuerdo a la pagina ingresada.
   */
  public changePageAfterEnter() {
    if (Number(this.actualPagePaginated) > this.pagesTotal) {
      this.actualPagePaginated = this.pageActual;
    } else {
      if (Number(this.actualPagePaginated) === this.pagesTotal) {
        this.pageActual = Number(this.actualPagePaginated);
      } else if (Number(this.actualPagePaginated) < 1) {
        this.actualPagePaginated = this.pageActual;
      } else {
        this.pageActual = Number(this.actualPagePaginated);
      }
    }
    this.savePosition();
    this.update2CurrentSize4Pdf();
  }

  /**
   * Obtiene el total de página del pdf actual.
   */
  getTotalPages() {
    return '/ ' + this.pagesTotal;
  }

  public isInvalidControl(ctrlName: string) {
    return this.pdfViewerForm.get(ctrlName).invalid && this.pdfViewerForm.get(ctrlName).touched;
  }

  /**
   * Evento disparado al realizar al cambiar el tamaño de la rubrica.
   * @param dragHandle
   */
  dragMove(dragHandle: HTMLElement) {
    this.ngZone.runOutsideAngular(() => {
      this.resize(dragHandle, this.resizeBoxElement);
    });
  }

  /**
   * Muestra ventana de las descripciones disponibles.
   */
  public openModalAssignSignatureDescription() {
    this.title = this.translate.instant('TITLE.ADD-DIGITAL-SIGNATURE-DESCRIPTION');
    const modalRef = this.modalService.open(AssignSignatureDescriptionComponent, {
      backdrop: 'static',
    });
    modalRef.componentInstance.signatureDescriptions = CloneTool.doList(this.signatureDescriptions);
    modalRef.componentInstance.personId = this.personId;
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        this.signatureDescriptions = LocalStorage.getSignatureDescriptions();
        Dialog.show(InformType.Success, this.title);
      } else if (InformType.Danger === result) {
        Dialog.show(InformType.Danger, this.title);
      }
    });
  }

  /**
   * Cambia el tamaño del contenedor de la imagen de la rúbrica.
   */
  resize(dragHandle: HTMLElement, target: HTMLElement) {
    const dragRect = dragHandle.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();
    const width = dragRect.left - targetRect.left + dragRect.width;
    const height = dragRect.top - targetRect.top + dragRect.height;
    target.style.width = width + 'px';
    target.style.height = height + 'px';
    this.setAllHandleTransform();
  }

  /**
   * Guarda las nuevas dimensiones de la rúbrica.
   */
  onDragEnded4Resize() {
    this.savePosition();
  }

  /**
   * Obtiene la posición actual del la rúbrica en el PDF
   */
  onDragEnded(event: CdkDragEnd) {
    const transform = event.source.element.nativeElement.style.transform;
    const regex = /translate3d\(\s?(?<x>[-]?\d*)px,\s?(?<y>[-]?\d*)px,\s?(?<z>[-]?\d*)px\)/;
    const values = regex.exec(transform);
    const positionX = this.positionDBx + (+values[1] + 2);
    const img = document.getElementById('rubricImage');
    const width = img.clientWidth;
    const height = img.clientHeight;
    this.newPositionX = Math.floor(positionX - (positionX * this.percentage4reductionPosition));
    this.lastValueWidth = Math.floor(width - (width * this.percentage4reductionPosition));
    this.lastValueHeight = Math.floor(height - (height * this.percentage4reductionPosition));
    this.lastValueY = Math.floor((this.rubricHeight - height) * this.percentage4reductionPosition1);
    if (width === Math.floor(this.rubricWidth)) {
      this.newPositionXf = Math.floor(this.newPositionX + this.rubricWidthDB);
    } else {
      this.newPositionXf = Math.floor(this.newPositionX + this.lastValueWidth);
    }
    const positionY = this.pdfContainerHeight - (+values[2]) - this.rubricHeight - this.positionDBy;
    if (height === Math.floor(this.rubricHeight)) {
      this.newPositionY = Math.floor(positionY - (positionY * this.percentage4reductionPosition));
      this.newPositionYf = Math.floor(this.newPositionY + this.rubricHeightDB);
    } else {
      this.newPositionY = Math.floor(positionY - (positionY * this.percentage4reductionPosition) + this.lastValueY);
      this.newPositionYf = Math.floor(this.newPositionY + this.lastValueHeight);
    }
    this.savePosition();
  }

  /**
   * Retorna las dimensiones del contenedor del PDF
   */
  get styleDimensionsPDF1(): string {
    return 'width: ' + this.pdfContainerWidth + 'px; height: ' + this.pdfContainerHeight + 'px;';
  }

  /**
   * Retorna las dimensiones del PDF
   */
  get styleDimensionsPDF(): string {
    if (this.pdfContainerWidth) {
      return 'width: ' + this.pdfContainerWidth1 + 'px; top: ' + this.topPdfPage + 'px; right: ' + this.rightPdfPage + 'px;';
    }
  }

  /**
   * Retorna el tamaño de letra.
   */
  get styleFontSize(): string {
    const img = document.getElementById('textarea');
    const width = img.clientWidth / 2 + img.clientHeight / 2;
    const size = width / 2;
    return 'font-size: ' + size + '%';
  }

  /**
   * Ubica la rubrica en una posición y tambien le pone sus dimensiones(ancho y alto.)
   */
  get styleDimensionsRubric2(): string {
    const positionRubric: Stamprubrictemporal = this.getPositionRubricBy(this.resource);
    if (positionRubric && this.pdfContainerHeight) {
      this.positionDBx = positionRubric.positionX * this.percentage4raisePosition;
      this.rubricWidthDB = positionRubric.positionXf - positionRubric.positionX;
      this.rubricHeightDB = positionRubric.positionYf - positionRubric.positionY;
      this.rubricWidth = this.rubricWidthDB * this.percentage4raisePosition;
      this.rubricHeight = this.rubricHeightDB * this.percentage4raisePosition;
      this.positionDBy = this.pdfContainerHeight - (positionRubric.positionY * this.percentage4raisePosition) - this.rubricHeight;
      return 'transform: translate3d(' + this.positionDBx + 'px, ' + this.positionDBy + 'px, ' + '0px); width: ' + String(this.rubricWidth) + 'px; height: ' + String(this.rubricHeight) + 'px;';
    }
  }

  /**
   * Obtiene las posiciones de la rubrica segun el parametro resource.
   * @param resource
   * @private
   */
  private getPositionRubricBy(resource: Resource) {
    if (this.showRubric) {
      this.positionRubrics = LocalStorage.getPositionRubrics();
      return this.positionRubrics.find(value => resource.id === value.resourceId);
    }
  }

  /**
   * Guarda las nuevas posiciones luego de realizar el arrastre o el cambio de tamaño de la imagen.
   * @private
   */
  private savePosition() {
    this.reloadingPdf = true;
    const img = document.getElementById('rubricImage');
    const width = img.clientWidth;
    const height = img.clientHeight;
    const positionRubric: Stamprubrictemporal = this.getPositionRubricBy(this.resource);
    const lastValueWidth = Math.floor(width - (width * this.percentage4reductionPosition));
    const lastValueHeight = Math.floor(height - (height * this.percentage4reductionPosition));
    if (this.newPositionX !== undefined) {
      positionRubric.positionX = this.newPositionX;
      if (this.lastValueWidth && this.lastValueWidth !== lastValueWidth) {
        positionRubric.positionXf = Math.floor(this.newPositionX + lastValueWidth);
      } else {
        positionRubric.positionXf = this.newPositionXf;
      }
      if (this.lastValueHeight && this.lastValueHeight !== lastValueHeight) {
        const lastValueY = (this.rubricHeight - height) * this.percentage4reductionPosition1;
        positionRubric.positionY = Math.floor(this.newPositionY - this.lastValueY + lastValueY);
        positionRubric.positionYf = Math.floor(this.newPositionYf);
      } else {
        positionRubric.positionY = this.newPositionY;
        positionRubric.positionYf = this.newPositionYf;
      }
    } else {
      if (width !== Math.floor(this.rubricWidth)) {
        const valueWidthTemporary = width - (width * this.percentage4reductionPosition);
        positionRubric.positionXf = Math.floor(valueWidthTemporary);
      }
      if (height !== Math.floor(this.rubricHeight)) {
        const valueYtemporary = (this.rubricHeight - height) * this.percentage4reductionPosition1;
        const valueHeightTemporary = height - (height * this.percentage4reductionPosition);
        positionRubric.positionY = Math.floor(positionRubric.positionY + valueYtemporary);
        positionRubric.positionYf = Math.floor(positionRubric.positionY + valueHeightTemporary);
      }
    }
    positionRubric.pageStamp = PagestampState.OTHER;
    positionRubric.page = this.pageActual;
    LocalStorage.setItem('positionRubrics', this.positionRubrics);
    this.rubricDragged.emit(this.resource);
    this.reloadPdfViewer();
  }
}



